import { axios } from '@/utils/request';

export function submitSpecialServiceApplication(application) {
  const needsDescription = application.service === 'OTHER';
  return axios({
    url: 'specialPassenger/add',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: JSON.stringify({
      passengerName: application.passengerName.trim(),
      phone: application.mobile.trim(),
      ticketNo: application.ticketNumber.trim(),
      flightNo: application.flightNumber.replace(/\s/g, '').toUpperCase(),
      flightDate: application.flightDate,
      depAirport: application.originCode.trim().toUpperCase(),
      arrAirport: application.destinationCode.trim().toUpperCase(),
      disabilityType: application.disability,
      serviceType: application.service,
      otherDescription: needsDescription ? application.otherText.trim() : ''
    })
  });
}
